<template>
  
  <div class="or-page-select flex-row row-ver-center row-space-between">
        <p :class="['menu-buttons', 'hover-pointer', {'active-color': button.url === page}, {'active-color': button.url === '/' && !page}]" 
            v-for="button in menu_buttons" 
            :key="button.key" 
            @click="redirect(button.url)" 
            >
            {{button.text}}</p>
  </div>

</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default {
    data() {
        return {
            menu_buttons: [
                {
                    key: 1,
                    text: 'Главная',
                    url: 'main',
                },
                {
                    key: 2,
                    text: 'О компании',
                    url: 'about',
                },
                {
                    key: 3,
                    text: 'Продукция',
                    url: 'production',
                },
                {
                    key: 4,
                    text: 'Покупателям',
                    url: 'buyers',
                },
                {
                    key: 5,
                    text: 'Новости',
                    url: 'news',
                },
                {
                    key: 6,
                    text: 'Контакты',
                    url: 'contacts',
                },
            ],
        }
    },
    computed: {
        ...mapGetters({page: 'getPage'}),
    },
    methods: {
        ...mapActions({changePage: 'changePage',
            changeIsPageReady: 'changeIsPageReady'}),
        redirect(url) {
            this.changePage({page: url})
            if (url === 'main') {
                this.changeIsPageReady({is: true});
            }
        }
    },
}
</script>

<style>
    .or-page-select {
        width: 535px;
        height: 16px;
    }
</style>